<template>
  <div class="pipeline-list">
    <div class="header">
      <h3 v-b-tooltip.hover :title="title">
        {{ title }}
      </h3>
      <div class="recap">
        {{ description }}
      </div>
      <div class="other w-100">
        <slot name="other"></slot>
      </div>
    </div>
    <div class="arrow"></div>

    <div
      class="buttons-container"
      :class="{ 'remove-add': remove || add, add: add && !remove, edit: edit, delete: deleteB }"
    >
      <h-b-action-rounded
        v-if="edit"
        :background-white="true"
        size="sm"
        class="edit-icon mr-1"
        icon="bx bx-edit-alt"
        name="Modifier"
        @click.native="handleEdit"
      ></h-b-action-rounded>
      <h-b-action-rounded
        v-if="deleteB"
        :background-white="true"
        class="delete-icon"
        size="sm"
        icon="bx bx-trash-alt"
        name="Ajouter"
        @click.native="handleDelete"
      ></h-b-action-rounded>
      <h-b-action-rounded
        v-if="otherButton"
        :background-white="true"
        size="sm"
        class="edit-icon mr-1"
        :icon="otherButton"
        @click.native="handleOther"
      ></h-b-action-rounded>
      <i
        v-if="remove"
        v-b-tooltip.hover
        class="bx bx-minus-circle bx-sm cursor-pointer remove-icon"
        title="Enlever"
        @click="handleRemove"
      ></i>
      <i
        v-if="add"
        v-b-tooltip.hover
        class="bx bx-plus-circle bx-sm cursor-pointer add-icon"
        title="Ajouter"
        @click="handleAdd"
      ></i>
    </div>
    <div v-if="container" class="card-container">
      <slot name="cards"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',

  props: {
    // eslint-disable-next-line vue/require-default-prop
    title: {
      type: String,
      require: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    description: [String, Number, Array],
    add: {
      type: Boolean,
      default: false,
    },
    remove: {
      type: Boolean,
      default: false,
    },
    container: {
      type: Boolean,
      default: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    deleteB: {
      type: Boolean,
      default: false,
    },
    otherButton: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleAdd() {
      this.$emit('add')
    },

    handleRemove() {
      this.$emit('remove')
    },

    handleDelete() {
      this.$emit('delete')
    },

    handleEdit() {
      this.$emit('edit')
    },

    handleOther() {
      this.$emit('other')
    },
  },
}
</script>

<style scoped></style>
